import React from 'react'
import PubSub from 'pubsub-js'
import PrintContent from './PrintContent'
import PrintSearch from './PrintSearch'
import Loading from '../../components/Loading/Loading'
import apiBarcode from '../../services/api/apiBarcode'
import {pushNewItemHistory} from "../../services/api/apiItemHistory"
import ableToPrint from "../../components/AbleToPrint/ableToPrint"

class PrintPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            barcodeNumber: '',
            item: null,
            isLoading: false,
            isShowSearch: true
        }
    }

    componentDidMount() {
        PubSub.subscribe('FOCUS_INPUT_SEARCH', this._showSearch)
    }

    _showSearch = () => {
        this.setState({
            isShowSearch: true,
            barcodeNumber: ''
        })
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _handleReset = () => {
        this.setState({
            barcodeNumber: '',
            item: null,
            isLoading: false,
            isShowSearch: true
        })
    }

    _fetchItem = async (init = false) => {
        const {barcodeNumber} = this.state

        if (!barcodeNumber) return

        try {
            if (!barcodeNumber.startsWith('#')) throw new Error('Invalid ID.')

            const trimmedNumber = barcodeNumber.replace('#', '')
            const codes = trimmedNumber.split('_')

            const resRead = await apiBarcode.getBarcodeByNumber(codes[0], 'page=printPage&item=' + codes[1])

            const {success, data, message} = resRead.data

            if (!success) throw Error(message)

            if (!data) throw new Error('No items found.')

            this.setState({
                item: data,
                isLoading: false
            }, async () => {
                if (!init) return false

                await ableToPrint(barcodeNumber, 'print_2d', this._handleReset)

                return pushNewItemHistory(barcodeNumber, {
                    event_key: 'scan_to_print',
                    event_description: 'Scan QR to print.'
                })
            })
        } catch (e) {
            alert(e.message)
            this.setState({
                isShowSearch: true,
                item: null,
                isLoading: false
            })
        }
    }

    _handleSubmit = async (e) => {
        e.preventDefault()

        if (!this.state.barcodeNumber.trim()) return this.setState({barcodeNumber: ''})

        this.setState({
            isLoading: true,
            isShowSearch: false
        })

        await this._fetchItem(true)
    }

    _renderLoading = () => {
        if (this.state.isLoading) return <Loading/>
    }

    _renderContent = () => {
        const {isLoading, item, barcodeNumber} = this.state

        if (!isLoading && item) {
            return <PrintContent barcodeNumber={barcodeNumber} item={item} reloadItem={this._fetchItem}/>
        }
    }

    render() {
        const {barcodeNumber, isShowSearch} = this.state

        return (
            <div className='PrintPage'>
                {
                    isShowSearch && <PrintSearch
                        onSubmit={this._handleSubmit}
                        onChangeInput={this._handleChangeInput}
                        value={barcodeNumber}
                    />
                }

                {
                    !isShowSearch && this._renderLoading()
                }

                {
                    !isShowSearch && this._renderContent()
                }
            </div>
        )
    }
}

export default PrintPage
